import { Term } from "@hub/settings/src/modules/terms/class/term.class"

export const initialState = () => ({
  term: new Term({}),
  activateTermInEdit: false,
  creatingTerm: false,
  viewOnlyTerm: false,
  currentStep: 0,
  loading: false,
  layout: {
    layoutType: "",
    fetchingChains: false,
    chainsData: [],
    chain: [],
  },
  coverageOptions: [],
  cityStateSelected: "",
  citiesSelecteds: []
})
